import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BillyService } from './@pages/billyService/billy.service';
import { CookieAuthService } from './@shared/storage-variables/cookie-auth.service';
import {
  InventoryWarningNotificationComponent,
  VOneAlertComponent,
} from '@shared-components';
import { AppUpdateService } from './uplift/shared/services/app-update/app-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    RouterOutlet,
    VOneAlertComponent,
    InventoryWarningNotificationComponent,
  ],
})
export class AppComponent implements OnInit {
  title = 'client';
  private readonly appUpdateService = inject(AppUpdateService);

  private static readonly LANGUAGE_STORAGE_KEY = 'app-language';
  private static readonly SUPPORTED_LANGS = ['es', 'en'];
  private static readonly DEFAULT_LANG = 'es';

  constructor(
    private translate: TranslateService,
    private billyService: BillyService,
    private cookieAuthService: CookieAuthService,
  ) {
    this.translate.addLangs(AppComponent.SUPPORTED_LANGS);
    this.initializeLanguage();
  }

  ngOnInit() {
    this.billyService.assignToken();
    this.cookieAuthService.initializeAuthData();
    this.appUpdateService.startVersionCheck();
  }

  private initializeLanguage(): void {
    const savedLanguage = localStorage.getItem(
      AppComponent.LANGUAGE_STORAGE_KEY,
    );
    const browserLang = this.translate.getBrowserLang();

    let languageToUse = savedLanguage;

    if (
      !languageToUse &&
      browserLang &&
      AppComponent.SUPPORTED_LANGS.includes(browserLang)
    ) {
      languageToUse = browserLang;
    }

    languageToUse = languageToUse || AppComponent.DEFAULT_LANG;

    this.translate.setFallbackLang(AppComponent.DEFAULT_LANG);
    this.translate.use(languageToUse);

    if (!savedLanguage) {
      localStorage.setItem(AppComponent.LANGUAGE_STORAGE_KEY, languageToUse);
    }
  }
}
